import axios from 'axios'

let baseUrl = 'https://callingly.com'

if (window.location.hostname === 'localhost' || window.location.hostname === '[::1]') {
  baseUrl = 'https://callingly.test'
} else if (window.location.hostname.endsWith('callingly.dev')) {
  baseUrl = 'https://callingly.dev'
}

const instance = axios.create({
  baseURL: baseUrl,
  withCredentials: true,
})

export default instance

export { baseUrl }
